import { StateState } from '../types'
import State from '../../models/state'
import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import ApiResponse from 'models/apiResponse'

//Get an State from a Vue component by calling this.$store.state.State.list;

const state: StateState = {
    list: [],
    timestampMS: null
}

const getters: GetterTree<StateState, any> = {
    getStateList: state => () => {
        return state.list;
    }
}

const mutations: MutationTree<StateState> = {
    setStateList(state, data) {
        //reset list first.
        state.list = [];
        data.forEach((State: State, index) => {
            Vue.set(state.list, index, State);
        });
    },
    setStateTimestamp(state) {
        // 24 hours
        const expiration = 24 * 60 * 60 * 1000;
        state.timestampMS = new Date().getTime() + expiration;
    }
}

const actions: ActionTree<StateState, any> = {
    async fetchStateList({ commit, state, dispatch }) {
        if (state.list.length == 0 || (state.timestampMS && new Date().getTime() > state.timestampMS)) {
            await dispatch('refreshStateList');
        }
    },
    async refreshStateList({ commit, state }) {
        const url = Vue.IdentityConfig.legacyApiUri + "/state";
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: "no-cache"
        };
        await fetch(url, options)
            .then(response => response.json() as Promise<ApiResponse<State[]>>)
            .then(data => {
                if (data.result && data.result.length > 0) {
                    const States = [];
                    data.result.forEach(f => {
                        States.push(new State(f));
                    })
                    commit('setStateList', States);
                    commit('setStateTimestamp');
                }
                if (data.errors) {
                    data.errors.forEach(e => Vue.Logger.LogError(e.message));
                }
            });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}